export default __webpack_public_path__ + "precision_m716694.png";